import { Quota } from "../../schema/types/quota";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export const quotaHelpers = {
  getQuota(quota: Quota) {
    return `${quota.current}/${quota.max}`;
  },
  getGvcLink(quota: Quota) {
    return quota.dimensions?.gvcLink || "";
  },
  getQuotaRouteLink(quota: Quota) {
    const selfLink = linksOf(quota).self!;
    return `${selfLink}:s:${quota.name}`;
  },
};

export interface QuotaTableItem extends Quota {
  selfLink: string;
  quota: string;
  idName: string;
  gvcLink: string;
  quotaRouteLink: string;
}

interface GetQuotaTableItemProps {
  link?: string;
  name?: string;
  item?: Quota;
}
export function getQuotaTableItem({ link, name, item }: GetQuotaTableItemProps): QuotaTableItem {
  if (item) {
    const idName = item.id + ":s:" + item.name;
    const quota = quotaHelpers.getQuota(item);
    const gvcLink = quotaHelpers.getGvcLink(item);
    const quotaRouteLink = quotaHelpers.getQuotaRouteLink(item);
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      idName: idName,
      quota: quota,
      gvcLink: gvcLink,
      quotaRouteLink: quotaRouteLink,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "quota",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      gvcLink: "",
      idName: `none:s:${name}`,
      quota: "",
      quotaRouteLink: "",
      origin: "default",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "quota",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    gvcLink: "",
    idName: `none:s:${name}`,
    quota: "",
    quotaRouteLink: "",
    origin: "default",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
